<template>
  <!-- <Row style="padding:10px;">
    <Col span="14" offset="0"> -->
      <!-- <Card> -->
        <!-- <p slot="title">完善用户信息</p> -->

        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
          <Alert type="warning" show-icon closable v-if="formValidate.userTYPE=='2'">
            友情提示：
            <template slot="desc">原太仓市人才网用户可使用人才网账号直接登录，无需注册。
            </template>
          </Alert>
          <Form-item label="用户类型" prop="userTYPE">
            <RadioGroup v-model="formValidate.userTYPE" type="button"  >
              <Radio label="2" >单位用户</Radio>
<!--              <Radio label="1" >人力资源机构用户</Radio>-->
            </RadioGroup>

          </Form-item>
          <FormItem label="用户名" prop="username">
            <Input v-model="formValidate.username" placeholder=""></Input>
          </FormItem>

          <FormItem label="用户密码" prop="password">
            <Input type ="password" v-model="formValidate.password" placeholder="密码不能小于8位，必须包含数字，英文大小写，特殊符号"></Input>
          </FormItem>
          <FormItem label="单位社保编号" prop="aab001" >
            <Input v-model="formValidate.aab001" placeholder="请输入单位编号"></Input>
          </FormItem>
          <FormItem label="单位名称" prop="nickname" v-if="formValidate.nickname">
            <Input v-model="formValidate.nickname" placeholder="请输入单位名称" readonly></Input>
          </FormItem>
          <FormItem label="手机号码" prop="phone">
            <Row>
              <i-col span="16"> <Input v-model="formValidate.phone" placeholder="请输入手机号码"></Input></i-col>
              <i-col span="4">  <Button @click="getcheckcode('formValidate')" style="margin-left: 10px;" :disabled="!show">
                <span v-show="show" >获取验证码</span>
                <span v-show="!show" class="count">{{count}} s</span>
              </Button></i-col>
            </Row>
          </FormItem>
          <FormItem label="验证码" prop="checkcode">
            <Input v-model="formValidate.checkcode" placeholder="请输入验证码"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" :loading="loading" @click="handleSubmit('formValidate')">注册</Button>
            <Button @click="handleReset('formValidate')" style="margin-left: 10px">重置</Button>
          </FormItem>
        </Form>
      <!-- </Card> -->
    <!-- </Col span="25">
  </Row> -->
</template>
<script>
  import {checkphoneNumberValid } from '@/libs/util';
  import {binguser,getcode} from '@/api/user.js'
export default {
  name: 'RegisterForm',
  props: {
    mail: {
      type: String
    },
    username: {
      type: String
    }
  },
  data () {

      let phonePass = (rule, value, cb)=>{
      let val=checkphoneNumberValid(value)
      if(val==true){
        cb()
      }else {
        cb(new Error('手机号码输入有误！'))
      }
    }
    return {
      show: true,
      count: '',
      timer: null,
      loading: false,
      formValidate: {
        phone:'',
        checkcode:'',
        username: '',
        nickname: '',
        password: '',
        userTYPE: '2',
        aab001: '',
        idcard: '',
      },
      ruleValidate: {
        phone: [
          {
            required: true,
            validator: phonePass,
            trigger: 'blur'
          },
        ],
        // checkcode: [
        //   {
        //     required: true,
        //     message: '验证码不能为空',
        //     trigger: 'blur'
        //   },
        // ],
        aab001: [
          {
            required: true,
            message: '单位注册编号不能为空',
            trigger: 'blur'
          },
        ],
        userTYPE: [
          {
            required: true,
            message: '选择用户类型',
            trigger: 'change'
          },
      ],
        username: [
          {
            required: true,
            message: '用户名不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 3,
            max: 20,
            message: '不能超过20个字符',
            trigger: 'blur'
          }
        ],

        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 8,
            message: '密码不能小于8位',
            trigger: 'blur'
          }
        ]

      }
    }
  },
  watch: {
    mail (value) {
      this.formValidate.email = value
    },
    username (value) {
      this.formValidate.username = value
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.formValidate.checkcode) {
            //this.$emit('on-submit-success', this.formValidate)
            this.loading = true
            setTimeout(() => {
              this.loading = false
              binguser(this.formValidate).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)

                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
                // this.getOrderList()
              })
            }, 1000)
          }else{
            this.$Message.error('请输入验证码')
          }
        } else {
          this.$Message.error('请输入完整资料')
        }
      })
    },
    getcheckcode (name) {

      this.$refs[name].validate(valid => {
        if (valid) {
          setTimeout(() => {

            getcode(this.formValidate, 'get').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.formValidate.nickname = res.data.data.AAB004
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
              // this.getOrderList()
            })
          }, 1000)
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }});


    },

    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
